import { fork, all } from 'redux-saga/effects';

import * as Maps from './Maps';

export default function* rootSaga() {
  yield all([...Object.values(Maps)].map(fork));
}
